// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2eoRG","buttons":"PendingPaymentAlert_buttons__3--y6"};